export const SHORTCUT_TOGGLE_FULLSCREEN =
    "publishpress-future/workflow-editor/toggle-fullscreen";
export const SHORTCUT_FIT_VIEW = "publishpress-future/workflow-editor/fit-view";
export const SHORTCUT_TOGGLE_INSERTER =
    "publishpress-future/workflow-editor/toggle-inserter";
export const SHORTCUT_AUTO_LAYOUT =
    "publishpress-future/workflow-editor/auto-layout";
export const SHORTCUT_TOGGLE_SIDEBAR =
    "publishpress-future/workflow-editor/toggle-sidebar";
export const SHORTCUT_TOGGLE_DEVELOPER_MODE =
    "publishpress-future/workflow-editor/toggle-developer-mode";
export const SHORTCUT_TOGGLE_ADVANCED_SETTINGS =
    "publishpress-future/workflow-editor/toggle-advanced-settings";
export const SHORTCUT_SAVE_AS_CURRENT_STATUS =
    "publishpress-future/workflow-editor/save-as-current-status";
